<div class="PolicyDashboard">
    <div class="Loading" *ngIf="isShowLoading==true">
        <div class="loader"></div>
        <label class="loaderlabel">Please wait while Processing....</label>
    </div>

    <div class=" ">
        <div class="row">
            <div class="col-md-12">
                <div class="card" id="InsuranceModel">
                    <ul class="nav nav-tabs" role="tablist">
                        <li id="tab1head" role="presentation" class="active">
                            <a href="#home" aria-controls="home" role="tab" data-toggle="tab">{{'Motor'|translate}}</a>
                        </li>
                    </ul>
                    <div class="tab-content PolicyPage">
                        <div role="tabpanel" class="tab-pane active" id="home">
                            <div class="row">
                                <div class="col-md-12 proposals">
                                    <table class="table table-striped table-bordered table-list">
                                        <thead>
                                            <tr>
                                                <th>{{'Policy No'|translate}}</th>
                                                <th>{{'Policy Issue Date' | translate }}</th>
                                                <th>{{'Policy To Date'|translate}}</th>
                                                <th>{{'Sequence No'| translate }}</th>
                                                <th>{{'Custom Id'| translate }}</th>
                                                <th>{{'Vehicle Plate No'|translate}}</th>
                                                <th>{{'Action'|translate}}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let policy of objRPList">
                                                <td>{{policy.PolicyNo}}</td>
                                                <td>{{policy.PolicyIssueDate}}</td>
                                                <td>{{policy.PolicyToDate}}</td>
                                                <td>{{policy.VehicleSequenceNo}}</td>
                                                <td>{{policy.VehicleCustomId}}</td>
                                                <td>{{ policy.VehiclePlateNo_En}}</td>

                                                <td>
                                                    <button class="btn btn-primary" id="btnRenew" name="btnRenew"
                                                        (click)="goForRenew(policy)">{{'Renew' | translate}}</button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/RenewalPolicies/RenewalPolicies.html